import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISideBarNotification } from '@core/models';
import { firstValueFrom } from 'rxjs';
import { ApicService } from './apic.services';
import { ConfigService } from './config.service';

@Injectable()
export class SideBarNotificationService {

  basePath: string;

  constructor(private configService: ConfigService, private httpClient: HttpClient, private apicService: ApicService) {
    this.basePath = `${this.apicService.apiPath}${this.configService.appConfig.api.baseUrl}`;
  }

  getNotificationList(): Promise<ISideBarNotification[]> {
    return firstValueFrom(this.httpClient.get<ISideBarNotification[]>(`${this.basePath}/notification/list`));
  }
}
